import { render } from "./StudentOwnDailyChallengesView.vue?vue&type=template&id=16463593"
import script from "./StudentOwnDailyChallengesView.vue?vue&type=script&lang=js"
export * from "./StudentOwnDailyChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__